import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteCustomBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.deleteCustomBadge,
  {
    mutationKey: ['deleteCustomBadge'],
  },
)
